import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

/**
 * Aeven homepage mounted at the root path. Replaces the previous behaviour of
 * redirecting `/` straight to the raw catalog list (#10118); the catalog index
 * moved to /catalog (see app-config.yaml `page:catalog`).
 *
 * What the page shows is four sections, in the order the user needs them: a
 * dashboard of their estate, the provisioning shortcuts they use most, their
 * own components, and the shared platform services collapsed at the bottom. The
 * hero, the duplicate search field and the hardcoded "Create a VM environment"
 * button that stood here before are gone - search lives in the sidebar, and a
 * single template does not deserve the largest button on the front page.
 */
const aevenHomePage = PageBlueprint.make({
  name: 'home',
  params: {
    path: '/',
    noHeader: true,
    loader: () => import('./AevenHomePage').then(m => <m.AevenHomePage />),
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [aevenHomePage],
});
